import { useState } from 'react';
import { BankClient, BankDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useBankApi = () => {
    const apiClient = new BankClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: BankDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createBank(data);
        } catch (err: any) {
            setError(err.message || 'Error creating Bank');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: BankDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateBank(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating Bank');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getBankById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching Bank');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchBanks(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching Banks');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteBank(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting Bank');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};